import axios from "axios";
import * as XLSX from "xlsx";
import Modal from "react-modal";
import css from "./VendorInvoices.css";
import { DatePicker } from "rsuite";
import { AES, enc } from 'crypto-js';
import moment from "moment-timezone";
import subDays from "date-fns/subDays";
import { toast } from "react-toastify";
import { Column } from "primereact/column";
import "react-toastify/dist/ReactToastify.css";
import { Link, useParams, useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";
import { DataTable } from "primereact/datatable";
import isEqual from "lodash/isEqual";
import invStatus from "../../../constants/invStatus";
import VendorInvoiceModal from "./elements/vendorInvoiceModal";
import { useSelector, useDispatch } from "react-redux";
import { renderVendorInvoiceCTA } from "../../../helpers/invoiceHelpers";
import React, { useState, useRef, useEffect } from "react";
import profile_image from "../../../images/user/Default_pfp.png";
import VendorWisePaymentStatus from "./elements/vendorPaymentStatusWise";
import invStatusConsts from "../../../constants/invStatusConsts";
import { logout, reset } from "../../../features/auth/authSlice";
import InvoiceImage from "../../../images/icons/invoice-icon-1.svg";
import DownloadImage from "../../../images/icons/download-icon.svg";
import crssrImage from "../../../images/singleinvoice/cross-red.svg";
import payStatusConsts from "../../../constants/invPaymetStatusConsts";
import { createDateConvert, dateVenInvConvert } from "../../../helpers/dateHelper";
import { setHeaderText } from "../../../features/headerText/headerTextSlice";
import { reset as invoiceReset } from "../../../features/invoice/invoiceSlice.js";
import { reset as headerReset } from "../../../features/headerText/headerTextSlice.js";
import { reset as appSettingsReset } from "../../../features/appSettings/appSettingsSlice.js";
import userTypeConsts from "../../../constants/userTypeConsts.js";
import { useGetTeams } from "../../TimeTracker/TimeTrackerOverview/useTimeTracker.jsx";
import TruncateFilterFieldView from "../../helpers/truncateFilterFieldView.js";
import { useFetchVendorInvoices } from "./useVendorInvoice.jsx";
import LeftArrow from "../../../images/icons/blue-left-arrow.svg";
import venInvPaymStatus from "../../../constants/venInvPaymStatus.js";
import venInvStatusConsts from "../../../constants/venInvStatusConsts.js";
import venInvoiceStatus from "../../../constants/venInvoiceStatus.js";
import CalendarIcon from '../../ui/CalendarIcon';


const ranges = [
  {
    label: "today",
    value: new Date(), // Use a single date instead of an array
  },
  {
    label: "yesterday",
    value: subDays(new Date(), 1),
  },
];

const VendorInvoices = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const { encryptedId } = useParams();
  const decodedId = decodeURIComponent(encryptedId.replace(/%2F/g, '/'));
  const decryptedBytes = AES.decrypt(decodedId, 'encryptionKey');
  const id = decryptedBytes.toString(enc.Utf8);
  const [selectedDate, setSelectedDate] = useState(null);
  // const [isLoading, setIsLoading] = useState(true);
  const [paymentStatusFilter, setPaymentStatusFilter] = useState("All");
  const [statusFilter, setStatusFilter] = useState("All");
  const [invTypeFilter, setInvTypeFilter] = useState("All");
  const [userFilter, setUserFilter] = useState("All");
  const [invoiceNumberFilter, setInvoiceNumberFilter] = useState("");
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(0);
  const [invStatusList, setInvStatusList] = useState([]);
  const [invPaymStatusList, setInvPaymStatusList] = useState([]);
  const [invoiceTypeModalIsOpen, setInvoiceTypeModalIsOpen] = useState(false);
  const [isAutomaticInv, setIsAutomaticInv] = useState(false);
  const [selectAllTeam, setSelectAllTeam] = useState(true);
  const [selectedTeams, setSelectedTeams] = useState([]);
  const [isTeamDropdownOpen, setIsTeamDropdownOpen] = useState(false);
  const previousSelectedTeamsRef = useRef([]);
  const previousTeamsRef = useRef([]);
  const previousSelectedStatusRef = useRef([]);
  const previousInvStatusListRef = useRef([]);
  const previousSelectedPaymentStatusRef = useRef([]);
  const previousInvPaymStatusListRef = useRef([]);
  const [selectAllStatus, setSelectAllStatus] = useState(true);
  const [selectedStatus, setSelectedStatus] = useState([]);
  const [isStatusDropdownOpen, setIsStatusDropdownOpen] = useState(false);
  const [isStatusModalDropdownOpen, setIsStatusModalDropdownOpen] = useState(false);
  const [selectAllPaymentStatus, setSelectAllPaymentStatus] = useState(true);
  const [selectedPaymentStatus, setSelectedPaymentStatus] = useState([]);
  const [isPaymentStatusDropdownOpen, setIsPaymentStatusDropdownOpen] = useState(false);
  const [isPaymentStatusModalDropdownOpen, setIsPaymentStatusModalDropdownOpen] = useState(false);
  // const [selectedInvTypes, setSelectedInvTypes] = useState([]);
  const [selectAllInvType, setSelectAllInvType] = useState(true);
  const [showingDropdownOpen, setShowingDropdownOpen] = useState(false);
  const teamDropdownRef = useRef(null);
  const paymentStatusDropdownRef = useRef(null);
  const paymentStatusModalDropdownRef = useRef(null);
  const statusDropdownRef = useRef(null);
  const statusModalDropdownRef = useRef(null);
  const showingDropdownRef = useRef(null);
  var filteredData = [];
  const [sec2, setSec2] = useState(100);
  const [sec3, setSec3] = useState(100);
  const [selectAllByPage, setSelectAllByPage] = useState({});
  const [showFilterModal, setShowFilterModal] = useState(false);
  const [showConfirmationModal, setShowConfirmationModal] = useState(false);

  const handleDateChange = (date) => {
    setSelectedDate(date);
    setCurrentPage(0);
  };
  // const [products, setProducts] = useState([]);
  let token = null;
  const { user } = useSelector((state) => state.auth);
  if (user) {
    if (user && user.token) {
      token = user.token;
    }
  }
  const dashboradDate = useSelector(
    (state) => state.invoice.dashboardDateRange
  );
  const {
    data: teams = [],
    isLoading: teamLoading,
    isError: teamError,
  } = useGetTeams(token);
  const { data: vendorInvoiceList = [], isLoading, refetch: refetchVendorInvoiceList, isError } = useFetchVendorInvoices(id, token);

  useEffect(() => {
    // async function fetchInvoice() {
    //   try {
    //     const params = new URLSearchParams(location.search);
    //     const monthNumber = params.get("month");
    //     const year = new Date().getFullYear();
    //     var startDate = new Date(year, monthNumber - 1, 1);
    //     var endDate = new Date(year, monthNumber, 0);
    //     setIsLoading(true);
    //     if (monthNumber) {
    //       startDate = startDate;
    //       endDate = endDate;
    //     } else {
    //       const startDateWithOneMoreDay = new Date(dashboradDate[0]);
    //       startDateWithOneMoreDay.setDate(
    //         startDateWithOneMoreDay.getDate() - 1
    //       );
    //       startDate = new Date(dashboradDate[0]); // startDateWithOneMoreDay;
    //       const endDateWithOneMoreDay = new Date(dashboradDate[1]);
    //       endDateWithOneMoreDay.setDate(endDateWithOneMoreDay.getDate() - 1);
    //       endDate = new Date(dashboradDate[1]); // endDateWithOneMoreDay;
    //     }
    //     const response = await axios.post(
    //       "/api/invoices",
    //       {
    //         startDate: startDate,
    //         endDate: endDate,
    //       },
    //       {
    //         headers: {
    //           Authorization: `Bearer ${token}`,
    //         },
    //       }
    //     );

    //     setProducts(response.data);
    //     setIsLoading(false);
    //   } catch (error) {
    //     console.log(error);
    //     if (error.response?.data?.status === "deleted") {
    //       localStorage.removeItem("user");
    //       dispatch(logout());
    //       dispatch(reset());
    //       dispatch(invoiceReset());
    //       dispatch(headerReset());
    //       dispatch(appSettingsReset());
    //       toast.error("This user is deleted!", {
    //         position: "bottom-right",
    //         autoClose: 2000,
    //         hideProgressBar: false,
    //         closeOnClick: true,
    //         pauseOnHover: true,
    //         draggable: true,
    //         progress: undefined,
    //         theme: "light",
    //       });
    //       navigate("/");
    //       return;
    //     }
    //     alert("Something went wrong");
    //   }
    // }

    // fetchInvoice().then(() => { });
    refetchVendorInvoiceList();
    const statusList = venInvoiceStatus.ven_inv_status;
    const paymentStatusList = venInvPaymStatus.ven_inv_paym_status;
    setInvStatusList(statusList);
    setInvPaymStatusList(paymentStatusList);
    // Initialize selectedStatus and selectedPaymentStatus with all items
    if (statusList && statusList.length > 0) {
      setSelectedStatus(statusList.map((status) => status._id));
      setSelectAllStatus(true);
    }
    if (paymentStatusList && paymentStatusList.length > 0) {
      setSelectedPaymentStatus(paymentStatusList.map((paymentstatus) => paymentstatus._id));
      setSelectAllPaymentStatus(true);
    }
    // dispatch(setHeaderText("Vendor Overview"));
  }, [id]);

  // filteredData = vendorInvoiceList.filter((item) => {

  //   const currentDate = new Date().toISOString().slice(0, 10);

  //   if (paymentStatusFilter.includes(payStatusConsts.Pending) && (item.ven_inv_payment_status === 0) && moment(item.ven_inv_due_date).isAfter(currentDate, "day") && item.ven_inv_status !== 2) {
  //     return true;
  //   }
  //   if (paymentStatusFilter.includes(payStatusConsts.Rejected) && (item.ven_inv_status === 2)) {
  //     return true;
  //   }
  //   if (paymentStatusFilter.includes(payStatusConsts.Cancelled) && (item.ven_inv_status === 6)) {
  //     return true;
  //   }
  //   if (paymentStatusFilter.includes(payStatusConsts.Manually_Processed) && (item.ven_inv_payment_status === 2)) {
  //     return true;
  //   }
  //   if (paymentStatusFilter.includes(payStatusConsts.Payment_Processing) && (item.ven_inv_payment_status === 1)) {
  //     return true;
  //   }
  //   if (paymentStatusFilter.includes(payStatusConsts.Sucessfully_Processed) && (item.ven_inv_payment_status === 3)) {
  //     return true;
  //   }
  //   if (paymentStatusFilter.includes(payStatusConsts.Refund) && (item.ven_inv_payment_status === 7)) {
  //     return true;
  //   }
  //   if ((paymentStatusFilter.includes(payStatusConsts.Overdue) && (moment(item.ven_inv_due_date).isBefore(currentDate, "day") && ((item.ven_inv_payment_status !== 1) && (item.ven_inv_payment_status !== 2) && (item.ven_inv_status !== 2))))) {
  //     return true;
  //   }
  //   if (paymentStatusFilter === "All") {
  //     return true;
  //   }

  // });

  // filteredData = vendorInvoiceList?.filter((item) => {
  //   const currentDate = new Date().toISOString().slice(0, 10);
  //   if (
  //     paymentStatusFilter.includes(payStatusConsts.Pending) &&
  //     (item.ven_inv_payment_status !== 0 ||
  //       item.ven_inv_due_date <= currentDate ||
  //       item.ven_inv_status === invStatusConsts.Rejected)
  //   ) {
  //     return false;
  //   } else if (
  //     paymentStatusFilter.includes(payStatusConsts.Overdue) &&
  //     (item.ven_inv_payment_status !== 0 ||
  //       item.ven_inv_due_date > currentDate ||
  //       item.ven_inv_status === invStatusConsts.Rejected)
  //   ) {
  //     return false;
  //   } else if (
  //     paymentStatusFilter.includes(payStatusConsts.Rejected) &&
  //     (item.ven_inv_payment_status !== 0 ||
  //       item.ven_inv_status !== invStatusConsts.Rejected)
  //   ) {
  //     return false;
  //   } else if (
  //     paymentStatusFilter !== "All" &&
  //     !paymentStatusFilter.includes(item.ven_inv_payment_status)
  //   ) {
  //     return false;
  //   }

  //   // if (
  //   //   statusFilter.includes(venInvStatusConsts.Overdue) &&
  //   //   (item.ven_inv_status !== 0 ||
  //   //     item.ven_inv_due_date > currentDate ||
  //   //     item.ven_inv_status === invStatusConsts.Rejected)
  //   // ) {
  //   //   return false;
  //   // } else if (statusFilter !== "All" && !statusFilter.includes(item.ven_inv_status)) {
  //   //   return false;
  //   // }

  //   if (
  //     selectedDate &&
  //     new Date(item.ven_inv_due_date).toISOString().slice(0, 10) !==
  //     selectedDate.toISOString().slice(0, 10)
  //   ) {
  //     return false;
  //   }
  //   if (
  //     invoiceNumberFilter.trim() !== "" &&
  //     !item.ven_inv_number
  //       .toLowerCase()
  //       .includes(invoiceNumberFilter.trim().toLowerCase())
  //   ) {
  //     return false;
  //   }
  //   return true;
  // });

  const filter = {
    paymentStat: paymentStatusFilter,
    invoiceStat: statusFilter,
    seldate: selectedDate,
    invoiceNumber: invoiceNumberFilter,
  };


  filteredData = vendorInvoiceList && vendorInvoiceList.filter(item => {
    // If all filter criteria are set to non-filtering values, include the item
    if (filter['invoiceNumber'] === "" && filter['invoiceStat'] === "All" && filter['paymentStat'] === "All" && filter['seldate'] === null && filter['vendor_name'] === "All") {
      return true;
    } else {
      let ven_inv_payment_status = true;
      let ven_inv_status = true;
      let user = true;
      let ven_inv_number = true;
      let ven_inv_due_date = true;
      let vendor_name = true;

      // Check payment status
      if (filter['paymentStat'] !== "All" && !paymentStatusFilter.includes(item['ven_inv_payment_status'])) {

        ven_inv_payment_status = false;
        if (paymentStatusFilter.includes(0)) {
          const currentDate = new Date().toISOString().slice(0, 10);
          if (item.ven_inv_status === 2 && item['ven_inv_payment_status'] === 0) {
            ven_inv_payment_status = false;
          }

        }

        if (paymentStatusFilter.includes(payStatusConsts.Rejected)) {
          const currentDate = new Date().toISOString().slice(0, 10);
          if (item['ven_inv_status'] === invStatusConsts.Rejected && moment(item.ven_inv_due_date).isSameOrBefore(currentDate, "day")) {
            ven_inv_payment_status = true;
          }
        }

        if (paymentStatusFilter.includes(payStatusConsts.Overdue)) {
          const currentDate = new Date().toISOString().slice(0, 10);
          if (moment(item.ven_inv_due_date).isSameOrBefore(currentDate, "day") && item['ven_inv_status'] !== invStatusConsts.Rejected && item['ven_inv_payment_status'] !== payStatusConsts.Manually_Processed && item['ven_inv_payment_status'] !== payStatusConsts.Payment_Processing && item['ven_inv_payment_status'] !== payStatusConsts.Cancelled) {
            ven_inv_payment_status = true;
          }
        }
      }

      // Check invoice status
      if (filter['invoiceStat'] !== "All" && !statusFilter.includes(item['ven_inv_status'])) {
        ven_inv_status = false;
        if (statusFilter.includes(venInvStatusConsts.Overdue)) {
          const currentDate = new Date().toISOString().slice(0, 10);
          if (moment(item.ven_inv_due_date).isSameOrBefore(currentDate, "day") && item['ven_inv_status'] !== venInvStatusConsts.Invoice_Send && item['ven_inv_status'] !== venInvStatusConsts.Rejected && item['ven_inv_status'] !== venInvStatusConsts.Cancelled && item['ven_inv_status'] !== venInvStatusConsts.Payment_Processed) {
            ven_inv_status = true;
          }
        }
        if (statusFilter.includes(venInvStatusConsts.Pending)) {
          const currentDate = new Date().toISOString().slice(0, 10);
          if (moment(item.ven_inv_due_date).isAfter(currentDate, "day") && item['ven_inv_status'] !== venInvStatusConsts.Invoice_Send && item['ven_inv_status'] !== venInvStatusConsts.Rejected && item['ven_inv_status'] !== venInvStatusConsts.Cancelled && item['ven_inv_status'] !== venInvStatusConsts.Payment_Processed) {
            ven_inv_status = true;
          }
        }
      }

      if (
        invoiceNumberFilter.trim() !== "" &&
        !item.ven_inv_number
          .toLowerCase()
          .includes(invoiceNumberFilter.trim().toLowerCase())
      ) {
        ven_inv_number = false;
      }

      if (
        selectedDate &&
        (new Date(item.ven_inv_due_date)?.getFullYear() !== selectedDate.getFullYear() ||
          new Date(item.ven_inv_due_date)?.getMonth() !== selectedDate.getMonth() ||
          new Date(item.ven_inv_due_date)?.getDate() !== selectedDate.getDate())
      ) {
        ven_inv_due_date = false;
      }

      // if (vendorFilter.trim() !== "" &&
      //   !vendorName
      //     .toLowerCase()
      //     .includes(vendorFilter.trim().toLowerCase())) {
      //   vendor_name = false;
      // }


      if (ven_inv_payment_status === false || ven_inv_status === false || user === false || ven_inv_number === false || ven_inv_due_date === false || vendor_name === false) {
        return false;
      } else {
        return true;
      }

    }

  });

  filteredData = filteredData.filter((item) => {
    if (paymentStatusFilter.includes(0)) {
      if (item.ven_inv_status === 2) {
        return false;
      }
    }
    return true;
  });

  const totalResults = filteredData.length;
  const renderAmount = (rowData) => {
    var totalAmount = rowData.ven_inv_total_amount.toLocaleString("en-US", {
      style: "currency",
      currency: rowData.ven_inv_currency,
    });

    return <span> {totalAmount}</span>;
  };

  const handleCheckboxTeamChange = (teamId) => {
    const updatedSelection = [...selectedTeams];
    const index = updatedSelection.indexOf(teamId);

    if (index === -1) {
      // Add to selection
      updatedSelection.push(teamId);
    } else {
      // Remove from selection
      updatedSelection.splice(index, 1);
    }
    setCurrentPage(0);
    setSelectedTeams(updatedSelection);
  };

  const handleSelectAllTeamChange = () => {
    if (!selectAllTeam) {
      setSelectedTeams(teams.map((team) => team._id));
    } else {
      setSelectedTeams([]);
    }
    setSelectAllTeam(!selectAllTeam);
  };

  // Helper function to compare arrays by content
  const arraysEqual = (a, b) => {
    if (a.length !== b.length) return false;
    return a.every((val, index) => val === b[index]);
  };

  useEffect(() => {
    // Only update if the content actually changed
    const selectedTeamsChanged = !arraysEqual(previousSelectedTeamsRef.current, selectedTeams);
    const teamsChanged = !arraysEqual(previousTeamsRef.current, teams.map(team => team._id));
    
    if (selectedTeamsChanged || teamsChanged) {
      const teamsLength = teams.length;
      const selectedTeamsLength = selectedTeams.length;
      
      setSelectAllTeam(selectedTeamsLength === teamsLength && teamsLength > 0);
      if (selectedTeamsLength === teamsLength && teamsLength > 0) {
        setUserFilter("All");
      } else {
        setUserFilter(selectedTeams);
      }
      
      previousSelectedTeamsRef.current = selectedTeams;
      previousTeamsRef.current = teams.map(team => team._id);
    }
  }, [selectedTeams, teams]);

  const toggleTeamDropdown = () => {
    setIsTeamDropdownOpen(!isTeamDropdownOpen);
  };

  const handleCheckboxStatusChange = (statusId) => {
    const updatedSelection = [...selectedStatus];
    const index = updatedSelection.indexOf(statusId);

    if (index === -1) {
      // Add to selection
      updatedSelection.push(statusId);
    } else {
      // Remove from selection
      updatedSelection.splice(index, 1);
    }
    setCurrentPage(0);
    setSelectedStatus(updatedSelection);
  };

  const handleSelectAllStatusChange = () => {
    if (!selectAllStatus) {
      setSelectedStatus(invStatusList.map((status) => status._id));
    } else {
      setSelectedStatus([]);
    }
    setSelectAllStatus(!selectAllStatus);
  };

  useEffect(() => {
    // Only update if the content actually changed
    const selectedStatusChanged = !arraysEqual(previousSelectedStatusRef.current, selectedStatus);
    const invStatusListChanged = !arraysEqual(previousInvStatusListRef.current, invStatusList.map(status => status._id));
    
    if (selectedStatusChanged || invStatusListChanged) {
      const invStatusListLength = invStatusList.length;
      const selectedStatusLength = selectedStatus.length;
      
      setSelectAllStatus(selectedStatusLength === invStatusListLength && invStatusListLength > 0);
      if (selectedStatusLength === invStatusListLength && invStatusListLength > 0) {
        setStatusFilter("All");
      } else {
        setStatusFilter(selectedStatus);
      }
      
      previousSelectedStatusRef.current = selectedStatus;
      previousInvStatusListRef.current = invStatusList.map(status => status._id);
    }
  }, [selectedStatus, invStatusList]);

  const toggleStatusDropdown = () => {
    setIsStatusDropdownOpen(!isStatusDropdownOpen);
  };

  const toggleStatusModalDropdown = () => {
    setIsStatusModalDropdownOpen(!isStatusModalDropdownOpen);
  };

  const handleCheckboxPaymentStatusChange = (paymentStatusId) => {
    const updatedSelection = [...selectedPaymentStatus];
    const index = updatedSelection.indexOf(paymentStatusId);

    if (index === -1) {
      // Add to selection
      updatedSelection.push(paymentStatusId);
    } else {
      // Remove from selection
      updatedSelection.splice(index, 1);
    }
    setCurrentPage(0);
    setSelectedPaymentStatus(updatedSelection);
  };

  const handleSelectAllPaymentStatusChange = () => {
    if (!selectAllPaymentStatus) {
      setSelectedPaymentStatus(
        invPaymStatusList.map((paymentstatus) => paymentstatus._id)
      );
    } else {
      setSelectedPaymentStatus([]);
    }
    setSelectAllPaymentStatus(!selectAllPaymentStatus);
  };

  useEffect(() => {
    // Only update if the content actually changed
    const selectedPaymentStatusChanged = !arraysEqual(previousSelectedPaymentStatusRef.current, selectedPaymentStatus);
    const invPaymStatusListChanged = !arraysEqual(previousInvPaymStatusListRef.current, invPaymStatusList.map(status => status._id));
    
    if (selectedPaymentStatusChanged || invPaymStatusListChanged) {
      const invPaymStatusListLength = invPaymStatusList.length;
      const selectedPaymentStatusLength = selectedPaymentStatus.length;
      
      setSelectAllPaymentStatus(
        selectedPaymentStatusLength === invPaymStatusListLength && invPaymStatusListLength > 0
      );
      if (selectedPaymentStatusLength === invPaymStatusListLength && invPaymStatusListLength > 0) {
        setPaymentStatusFilter("All");
      } else {
        setPaymentStatusFilter(selectedPaymentStatus);
      }
      
      previousSelectedPaymentStatusRef.current = selectedPaymentStatus;
      previousInvPaymStatusListRef.current = invPaymStatusList.map(status => status._id);
    }
  }, [selectedPaymentStatus, invPaymStatusList]);

  const togglePaymentStatusDropdown = () => {
    setIsPaymentStatusDropdownOpen(!isPaymentStatusDropdownOpen);
  };

  const togglePaymentStatusModalDropdown = () => {
    setIsPaymentStatusModalDropdownOpen(!isPaymentStatusModalDropdownOpen);
  };


  const handleClickOutsideDropdown = (event) => {
    const isClickInsideTeamDropdown =
      teamDropdownRef.current && teamDropdownRef.current.contains(event.target);
    const isClickInsidePaymentStatusDropdown =
      paymentStatusDropdownRef.current &&
      paymentStatusDropdownRef.current.contains(event.target);
    const isClickInsidePaymentStatusModalDropdown =
      paymentStatusModalDropdownRef.current &&
      paymentStatusModalDropdownRef.current.contains(event.target);
    const isClickInsideStatusDropdown =
      statusDropdownRef.current &&
      statusDropdownRef.current.contains(event.target);
    const isClickInsideStatusModalDropdown =
      statusModalDropdownRef.current &&
      statusModalDropdownRef.current.contains(event.target);
    const isClickInsideshowingDropdown =
      showingDropdownRef.current &&
      showingDropdownRef.current.contains(event.target);

    if (!isClickInsideTeamDropdown) {
      setIsTeamDropdownOpen(false);
    }
    if (!isClickInsideStatusDropdown) {
      setIsStatusDropdownOpen(false);
    }
    if (!isClickInsideStatusModalDropdown) {
      setIsStatusModalDropdownOpen(false);
    }
    if (!isClickInsidePaymentStatusDropdown) {
      setIsPaymentStatusDropdownOpen(false);
    }
    if (!isClickInsidePaymentStatusModalDropdown) {
      setIsPaymentStatusModalDropdownOpen(false);
    }
    if (!isClickInsideshowingDropdown) {
      setShowingDropdownOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener("click", handleClickOutsideDropdown);

    return () => {
      document.removeEventListener("click", handleClickOutsideDropdown);
    };
  }, []);

  const applyFilters = () => {
    setShowFilterModal(false);
  };

  const clearFilters = () => {
    setInvoiceNumberFilter("");
    setSelectedTeams(teams.map((team) => team._id));
    setSelectedStatus(invStatusList.map((status) => status._id));
    setSelectedPaymentStatus(
      invPaymStatusList.map((paymentstatus) => paymentstatus._id)
    );
    setSelectedDate(null);
    // setSelectedInvTypes(["Regular", "Reimbursement"]);
    setShowFilterModal(false);
  };

  const checkAndShowConfirmationModal = () => {
    const isInvNumModified = !isEqual(invoiceNumberFilter, "");
    const isStatusModified = !isEqual(selectedStatus, invStatusList.map((status) => status._id));
    const isPaymentStatusModified = !isEqual(selectedPaymentStatus, invPaymStatusList.map((paymentstatus) => paymentstatus._id));
    const isDueDateModified = !isEqual(selectedDate, null);

    if (
      isInvNumModified ||
      isStatusModified ||
      isPaymentStatusModified ||
      isDueDateModified
    ) {
      setShowConfirmationModal(true);
    } else {
      setShowFilterModal(false);
    }
  };

  const handleCancel = () => {
    setShowConfirmationModal(false);
  };

  const handleApplyConfirm = () => {
    setShowConfirmationModal(false);
    setShowFilterModal(false);
  };

  const toggleFilterModal = () => {
    setShowFilterModal(!showFilterModal);
  };

  useEffect(() => {
    // Only update if the content actually changed
    const teamsChanged = !arraysEqual(previousTeamsRef.current, teams.map(team => team._id));
    const invStatusListChanged = !arraysEqual(previousInvStatusListRef.current, invStatusList.map(status => status._id));
    const invPaymStatusListChanged = !arraysEqual(previousInvPaymStatusListRef.current, invPaymStatusList.map(status => status._id));
    
    if (teamsChanged && teams.length > 0) {
      setSelectedTeams(teams.map((team) => team._id));
      previousTeamsRef.current = teams.map(team => team._id);
    }
    
    if (invStatusListChanged && invStatusList.length > 0) {
      // Only update if selectedStatus is empty or doesn't match the list
      const allStatusIds = invStatusList.map(status => status._id);
      if (selectedStatus.length === 0 || !arraysEqual(selectedStatus, allStatusIds)) {
        setSelectedStatus(allStatusIds);
        setSelectAllStatus(true);
      }
      previousInvStatusListRef.current = allStatusIds;
    }
    
    if (invPaymStatusListChanged && invPaymStatusList.length > 0) {
      // Only update if selectedPaymentStatus is empty or doesn't match the list
      const allPaymentStatusIds = invPaymStatusList.map(paymentstatus => paymentstatus._id);
      if (selectedPaymentStatus.length === 0 || !arraysEqual(selectedPaymentStatus, allPaymentStatusIds)) {
        setSelectedPaymentStatus(allPaymentStatusIds);
        setSelectAllPaymentStatus(true);
      }
      previousInvPaymStatusListRef.current = allPaymentStatusIds;
    }
  }, [teams, invStatusList, invPaymStatusList]);
  // venInvStatusConsts
  const renderStatus = (rowData) => {
    let statusClass;
    let statusName;
    if (rowData.ven_inv_status === venInvStatusConsts.Approved) {
      statusClass = "manual";
      statusName = "Approved";
    } else if (rowData.ven_inv_status === venInvStatusConsts.Not_Reviewed) {
      // const startDate = moment().tz(global.config.getTimeZone());
      // const endDate = moment(rowData.ven_inv_due_date).tz(global.config.getTimeZone());
      // const diffInDays = endDate.diff(startDate, "days");
      // if (diffInDays < 0) {
      //   statusClass = "overdue";
      //   statusName = "Overdue";
      // } else {
      statusClass = "pending";
      statusName = "Not Reviewed";
      // }
    } else if (rowData.ven_inv_status === venInvStatusConsts.Rejected) {
      statusClass = "overdue";
      statusName = "Rejected";
    } else if (rowData.ven_inv_payment_status === venInvStatusConsts.Cancelled) {
      statusClass = "overdue";
      statusName = "Cancelled";
    }
    return (
      <span className={`payment-status ${statusClass}`}>{statusName}</span>
    );
  };

  const handleAutomaticModalOpen = async () => {
    setInvoiceTypeModalIsOpen(true);
  };

  const handleModalCancel = () => {
    setInvoiceTypeModalIsOpen(false);
  };

  const exportToExcel = () => {
    if (filteredData.length === 0) {
      toast.error("No data to export.", {
        position: "bottom-right",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      return;
    }

    try {
      const now = new Date();
      const formattedDate =
        now.getFullYear() +
        "-" +
        (now.getMonth() + 1).toString().padStart(2, "0") +
        "-" +
        now.getDate().toString().padStart(2, "0");
      const formattedTime =
        now.getHours().toString().padStart(2, "0") +
        ":" +
        now.getMinutes().toString().padStart(2, "0") +
        ":" +
        now.getSeconds().toString().padStart(2, "0");

      const modifiedLog = [];
      filteredData.forEach((item, index) => {
        const descriptions = item.ven_inv_description;
        const costs = item.ven_inv_cost;
        const taxs = item.ven_inv_tax;

        const renderStatus = () => {
          let statusName;
          if (item.ven_inv_status === venInvStatusConsts.Approved) {
            statusName = "Approved";
          } else if (item.ven_inv_status === venInvStatusConsts.Not_Reviewed) {
            const startDate = moment().tz(global.config.getTimeZone());
            const endDate = moment(item.ven_inv_due_date).tz(global.config.getTimeZone());
            const diffInDays = endDate.diff(startDate, "days");
            if (diffInDays < 0) {
              statusName = "Overdue";
            } else {
              statusName = "Not Reviewed";
            }
          } else if (item.ven_inv_status === venInvStatusConsts.Rejected) {
            statusName = "Rejected";
          } else if (item.ven_inv_payment_status === venInvStatusConsts.Cancelled) {
            statusName = "Cancelled";
          }
          return statusName;
        };

        const renderAmount = () => {
          const totalAmount = item.ven_inv_total_amount.toLocaleString("en-US", {
            style: "currency",
            currency: item.ven_inv_currency,
          });
          return totalAmount;
        };

        if (descriptions && descriptions.length > 0) {
          descriptions.forEach((description, i) => {
            const cost = parseFloat(costs[i]);
            const tax = parseFloat(taxs[i]);
            const vat = (cost * (tax / 100)).toFixed(2);
            const amount = (cost + parseFloat(vat)).toFixed(2);
            modifiedLog.push({
              "Invoice Number": item.ven_inv_number,
              "Invoice Due Date": moment(item.ven_inv_due_date)
                .tz(global.config.getTimeZone())
                .format("DD/MM/YYYY"),
              Status: renderStatus(),
              Amount: renderAmount(),
            });
          });
        } else {
          modifiedLog.push({
            "Invoice Number": item.ven_inv_number,
            "Invoice Due Date": moment(item.ven_inv_due_date)
              .tz(global.config.getTimeZone())
              .format("DD/MM/YYYY"),
            Status: renderStatus(),
            Amount: renderAmount(),
          });
        }
      });

      const workbook = XLSX.utils.book_new();
      const worksheet = XLSX.utils.json_to_sheet(modifiedLog);
      const colWidths = [
        { wpx: 80 },
        { wpx: 100 },
        { wpx: 100 },
        { wpx: 125 },
      ];
      worksheet["!cols"] = colWidths;

      // Add alignment to center align the first row and increase font size
      const firstRow = XLSX.utils.decode_range(worksheet["!ref"]).s.r;
      for (let i = 0; i < colWidths.length; i++) {
        const cell = XLSX.utils.encode_cell({ r: firstRow, c: i });
        const style = worksheet[cell]?.s || {};
        style.alignment = style.alignment || {};
        style.alignment.horizontal = "center";
        style.alignment.vertical = "center";
        style.font = { size: 14, bold: true };
        worksheet[cell] = { ...worksheet[cell], s: style };
      }

      // Set border for active area and increase font size
      const range = XLSX.utils.decode_range(worksheet["!ref"]);
      for (let row = range.s.r + 1; row <= range.e.r; row++) {
        for (let col = range.s.c; col <= range.e.c; col++) {
          const cell = XLSX.utils.encode_cell({ r: row, c: col });
          const style = worksheet[cell]?.s || {};
          style.font = { size: 12 };
          worksheet[cell] = { ...worksheet[cell], s: style };
        }
      }

      global.config.activityLog(
        window.location.href,
        "Invoice",
        "Invoices List exported to Excel"
      );
      const fileName = `Invoice_Report_${formattedDate}_${formattedTime}.xlsx`;
      worksheet["!autofilter"] = { ref: range };
      XLSX.utils.book_append_sheet(workbook, worksheet, "Invoice Report");
      XLSX.writeFile(workbook, fileName);
    } catch (error) {
      console.log(error);
      global.config.slackMessage(error.toString());
      global.config.activityLog(
        window.location.href,
        "Invoice",
        "Error occurred while exporting INVOICES to Excel"
      );
      alert("Error occurred while exporting to Excel.");
    }
  };

  const handleRowsPerPageChange = (e) => {
    const newRowsPerPage = parseInt(e.target.value);
    setRowsPerPage(newRowsPerPage);
    setCurrentPage(0); // Set the current page to 0 when changing rows per page
  };

  const onPageChange = (e) => {
    const newPage = e.page;
    // Store the current "Select All" state for the current page
    setSelectAllByPage((prevSelectAllByPage) => ({
      ...prevSelectAllByPage,
    }));
    setCurrentPage(e.page);
  };

  return (
    <div className="outer-invoice-clinet-section">
      <div className="invoice-outer-invoice">
        <div className="text-arrow-outer">
          <div className="text-arrow-inner">
            <Link to={`/vendor/details/${encodeURIComponent(AES.encrypt(id, 'encryptionKey').toString().replace(/\//g, '%2F'))}`}>
              <div className="text-arrow">
                <div className="left-arrow">
                  <img src={LeftArrow} alt="left-arrow" />
                </div>
                <div className="top-text">
                  Back to Overview
                </div>
              </div>
            </Link>
          </div>
        </div>
        <div className="invoice-top">
          <div className="new-top-flter">
            <div className="button-sec-invoice">
              <a onClick={handleAutomaticModalOpen}>
                <span className="icon-invoice">
                  <img src={InvoiceImage} alt="Create Invoice" />
                </span>
                Create Invoice
              </a>
              {/* invoice type modal */}
              <Modal
                isOpen={invoiceTypeModalIsOpen}
                onRequestClose={handleModalCancel}
                contentLabel="Invoice Type"
                style={{
                  content: {
                    height: "50%",
                    width: "50%",
                    position: "fixed",
                    top: "50%",
                    left: "50%",
                  },
                }}
              >
                <div className="modal">
                  <div className="outter-modal-main">
                    <a
                      className="close-image-clr1"
                      onClick={() => {
                        setInvoiceTypeModalIsOpen(false);
                      }}
                    >
                      <img src={crssrImage} alt="Edit Icon" />{" "}
                    </a>
                  </div>
                  <VendorInvoiceModal isAutomaticInv={isAutomaticInv} />
                </div>
              </Modal>
              {/* invoice type madal end */}
              <a onClick={exportToExcel}>
                <span className="icon-invoice">
                  <img src={DownloadImage} alt="Export" />
                </span>
                Export Data
              </a>
            </div>
            <div className="filter-invoice-right">
              <div className="filter-inner showing-result">
                <label>Showing</label>
                {/* <select
                  value={
                    totalResults < 10
                      ? totalResults.toString()
                      : rowsPerPage.toString()
                  }
                  onChange={handleRowsPerPageChange}
                >
                  {totalResults >= 10 && <option value="10">10</option>}
                  {totalResults >= 20 && <option value="20">20</option>}
                  {totalResults >= 30 && <option value="30">30</option>}
                  {totalResults >= 40 && <option value="40">40</option>}
                  {totalResults > 10 && <option value={totalResults.toString()}>ALL</option>}
                  {totalResults < 10 ? (
                    <option value={totalResults.toString()}>
                      {totalResults}
                    </option>
                  ) : null}
                </select> */}
                <div
                  ref={showingDropdownRef}
                  className="select-modal-mainM custom-dropdown-user-new-outer"
                >
                  <div
                    className="selected-option custom-dropdown-user-new"
                    onClick={() => setShowingDropdownOpen(!showingDropdownOpen)}
                  >
                    {totalResults < 10
                      ? totalResults.toString()
                      : rowsPerPage.toString()}
                  </div>
                  {showingDropdownOpen && (
                    <div className="custom-dropdown-new">
                      <ul className="showing-options-list">
                        {totalResults >= 10 && (
                          <li
                            className={rowsPerPage === 10 ? "selected-item" : ""}
                            onClick={() => {
                              handleRowsPerPageChange({ target: { value: 10 } });
                              setShowingDropdownOpen(false);
                            }}
                          >
                            10
                          </li>
                        )}
                        {totalResults >= 20 && (
                          <li
                            className={rowsPerPage === 20 ? "selected-item" : ""}
                            onClick={() => {
                              handleRowsPerPageChange({ target: { value: 20 } });
                              setShowingDropdownOpen(false);
                            }}
                          >
                            20
                          </li>
                        )}
                        {totalResults >= 30 && (
                          <li
                            className={rowsPerPage === 30 ? "selected-item" : ""}
                            onClick={() => {
                              handleRowsPerPageChange({ target: { value: 30 } });
                              setShowingDropdownOpen(false);
                            }}
                          >
                            30
                          </li>
                        )}
                        {totalResults >= 40 && (
                          <li
                            className={rowsPerPage === 40 ? "selected-item" : ""}
                            onClick={() => {
                              handleRowsPerPageChange({ target: { value: 40 } });
                              setShowingDropdownOpen(false);
                            }}
                          >
                            40
                          </li>
                        )}
                        {totalResults > 10 && (
                          <li
                            className={totalResults > 10 && rowsPerPage === totalResults ? "selected-item" : ""}
                            onClick={() => {
                              handleRowsPerPageChange({ target: { value: totalResults }, });
                              setShowingDropdownOpen(false);
                            }}
                          >
                            ALL
                          </li>
                        )}
                        {totalResults < 10 ? (
                          <li
                            className={totalResults < 10 ? "selected-item" : ""}
                            onClick={() => {
                              handleRowsPerPageChange({
                                target: { value: totalResults },
                              });
                              setShowingDropdownOpen(false);
                            }}
                          >
                            {totalResults}
                          </li>
                        ) : null}
                      </ul>
                    </div>
                  )}
                </div>
                <label>of {totalResults} Results</label>
              </div>
            </div>
          </div>

          <div className="invoice-filter">
            <div className="invoice-filter-inner-section no-flter-all">
              <div className="filter-inner invoice-id">
                <label htmlFor="fname">Invoice ID</label>
                <input
                  type="text"
                  onChange={(e) => {
                    setInvoiceNumberFilter(e.target.value);
                    setCurrentPage(0);
                  }}
                  value={invoiceNumberFilter}
                  id="invoiceId"
                  name="invoiceId"
                  placeholder="All"
                />
              </div>
              <div className="filter-inner invoice-status">
                <label htmlFor="invoiceStatus">Invoice Status</label>
                <div className="custom-dropdown1" ref={statusDropdownRef}>
                  <div className="drop-down-inner">
                    <div
                      className="selected-options1"
                      onClick={toggleStatusDropdown}
                    >
                      {selectedStatus.length === 0 ? (
                        <div className="placeholder">Select</div>
                      ) : (
                        <>
                          <div
                            className="selected-option1"
                            key={selectedStatus[0]}
                          >
                            {selectedStatus.length === invStatusList.length ? (
                              "All"
                            ) : (
                              <>
                                <TruncateFilterFieldView
                                  textContent={
                                    invStatusList.find(
                                      (item) => item._id === selectedStatus[0]
                                    )?.status
                                  }
                                />
                                {selectedStatus.length > 1 &&
                                  selectedStatus.length !==
                                  invStatusList.length && (
                                    <div className="selected-option-count">
                                      {selectedStatus.length - 1}+
                                    </div>
                                  )}
                              </>
                            )}
                          </div>
                        </>
                      )}
                    </div>
                    {isStatusDropdownOpen && (
                      <div className="dropdown-list1">
                        {invStatusList.length > 0 && (
                          <>
                            <label className="checkbox-label1" key="selectAll">
                              <input
                                type="checkbox"
                                checked={selectAllStatus}
                                onChange={handleSelectAllStatusChange}
                              />
                              All
                            </label>
                            {invStatusList.map((status) => (
                              <label className="checkbox-label1" key={status._id}>
                                <input
                                  type="checkbox"
                                  checked={selectedStatus.includes(status._id)}
                                  onChange={() =>
                                    handleCheckboxStatusChange(status._id)
                                  }
                                />
                                {status.status && `${status.status}`}
                              </label>
                            ))}
                          </>
                        )}
                      </div>
                    )}
                  </div>
                </div>
              </div>
              <div className="filter-inner payment-status">
                <label htmlFor="paymentStatus">Payment Status</label>
                <div className="custom-dropdown1" ref={paymentStatusDropdownRef}>
                  <div className="drop-down-inner">
                    <div
                      className="selected-options1"
                      onClick={togglePaymentStatusDropdown}
                    >
                      {selectedPaymentStatus.length === 0 ? (
                        <div className="placeholder">Select</div>
                      ) : (
                        <>
                          <div
                            className="selected-option1"
                            key={selectedPaymentStatus[0]}
                          >
                            {selectedPaymentStatus.length ===
                              invPaymStatusList.length ? (
                              "All"
                            ) : (
                              <>
                                <TruncateFilterFieldView
                                  textContent={
                                    invPaymStatusList.find(
                                      (item) =>
                                        item._id === selectedPaymentStatus[0]
                                    )?.status
                                  }
                                />
                                {selectedPaymentStatus.length > 1 &&
                                  selectedPaymentStatus.length !==
                                  invPaymStatusList.length && (
                                    <div className="selected-option-count">
                                      {selectedPaymentStatus.length - 1}+
                                    </div>
                                  )}
                              </>
                            )}
                          </div>
                        </>
                      )}
                    </div>
                    {isPaymentStatusDropdownOpen && (
                      <div className="dropdown-list1">
                        {invPaymStatusList.length > 0 && (
                          <>
                            <label className="checkbox-label1" key="selectAll">
                              <input
                                type="checkbox"
                                checked={selectAllPaymentStatus}
                                onChange={handleSelectAllPaymentStatusChange}
                              />
                              All
                            </label>
                            {invPaymStatusList.map((paymentstatus) => (
                              <label
                                className="checkbox-label1"
                                key={paymentstatus._id}
                              >
                                <input
                                  type="checkbox"
                                  checked={selectedPaymentStatus.includes(
                                    paymentstatus._id
                                  )}
                                  onChange={() =>
                                    handleCheckboxPaymentStatusChange(
                                      paymentstatus._id
                                    )
                                  }
                                />
                                {paymentstatus.status &&
                                  `${paymentstatus.status}`}
                              </label>
                            ))}
                          </>
                        )}
                      </div>
                    )}
                  </div>
                </div>
              </div>
              <div className="filter-inner due-date">
                <label htmlFor="dueDate" className="calendar-icon">
                  Due Date
                </label>
                <div className="date-picker-outer date-picker-outer-all">
                  <div className="custoom-icon-calender custoom-icon-calender-all">
                    <DatePicker
                      oneTap // Use DatePicker instead of DateRangePicker
                      format="dd/MM/yyyy"
                      ranges={ranges}
                      value={selectedDate}
                      onChange={handleDateChange}
                      placement="auto"
                      className="invoice-filter-top-date"
              caretAs={CalendarIcon}
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="filter-invoice-right apply-fliter-right">
              <button onClick={toggleFilterModal}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="13"
                  height="17"
                  viewBox="0 0 13 17"
                  fill="none"
                >
                  <path
                    d="M11.7363 8.81108C11.4276 9.81451 10.4925 10.5444 9.38889 10.5444C8.28471 10.5444 7.35016 9.8141 7.04147 8.81108L0.722221 8.81108C0.323349 8.81108 -1.07845e-06 8.48773 -1.06101e-06 8.08886C-1.04357e-06 7.68998 0.323349 7.36663 0.722221 7.36663L7.04144 7.36663C7.35022 6.3632 8.28529 5.6333 9.38889 5.6333C10.4931 5.6333 11.4276 6.36362 11.7363 7.36663L12.2778 7.36663C12.6767 7.36663 13 7.68998 13 8.08886C13 8.48773 12.6766 8.81108 12.2778 8.81108L11.7363 8.81108ZM9.38889 7.07775C8.83162 7.07775 8.37778 7.53123 8.37778 8.08886C8.37778 8.64613 8.83127 9.09997 9.38889 9.09997C9.94616 9.09997 10.4 8.64648 10.4 8.08886C10.4 7.53158 9.94651 7.07775 9.38889 7.07775Z"
                    fill="#6479F8"
                  />
                  <path
                    d="M5.38078 3.17778C5.072 4.18121 4.13693 4.91111 3.03333 4.91111C1.92882 4.91111 0.994035 4.18035 0.68563 3.17687C0.303759 3.15781 -1.07791e-06 2.84216 -1.06101e-06 2.45556C-1.04411e-06 2.06896 0.303748 1.75331 0.685606 1.73425C0.994098 0.730343 1.9294 -4.83911e-07 3.03333 -4.35657e-07C4.13752 -3.87392e-07 5.07206 0.730315 5.38076 1.73333L12.2778 1.73333C12.6767 1.73333 13 2.05668 13 2.45556C13 2.85443 12.6766 3.17778 12.2778 3.17778L5.38078 3.17778ZM3.03333 1.44444C2.47606 1.44444 2.02222 1.89793 2.02222 2.45556C2.02222 3.01283 2.47571 3.46667 3.03333 3.46667C3.5906 3.46667 4.04444 3.01318 4.04444 2.45556C4.04444 1.89828 3.59096 1.44444 3.03333 1.44444Z"
                    fill="#6479F8"
                  />
                  <path
                    d="M7.403 14.4444C7.09422 15.4478 6.15916 16.1777 5.05556 16.1777C3.95137 16.1777 3.01682 15.4474 2.70813 14.4444L0.722221 14.4444C0.323349 14.4444 -1.07845e-06 14.121 -1.06101e-06 13.7222C-1.04357e-06 13.3233 0.323349 12.9999 0.722221 12.9999L2.70811 12.9999C3.01689 11.9965 3.95195 11.2666 5.05556 11.2666C6.15974 11.2666 7.09429 11.9969 7.40298 12.9999L12.2778 12.9999C12.6767 12.9999 13 13.3233 13 13.7222C13 14.121 12.6766 14.4444 12.2778 14.4444L7.403 14.4444ZM5.05556 12.711C4.49828 12.711 4.04444 13.1645 4.04444 13.7222C4.04444 14.2794 4.49793 14.7333 5.05556 14.7333C5.61283 14.7333 6.06667 14.2798 6.06667 13.7222C6.06667 13.1649 5.61318 12.711 5.05556 12.711Z"
                    fill="#6479F8"
                  />
                </svg>
                All Filters
              </button>
            </div>
            <Modal
              isOpen={showFilterModal}
              onRequestClose={toggleFilterModal}
              contentLabel="Filter Modal"
              className="new-filter-modal"
              style={{
                content: {
                  height: "50%",
                  width: "50%",
                  position: "fixed",
                  top: "50%",
                  left: "50%",
                  borderRadius: "10px",
                  boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
                  backgroundColor: "#fff",
                  padding: "20px",
                  // overflow: "auto",
                },
                overlay: {
                  backgroundColor: "rgba(0, 0, 0, 0.5)",
                },
              }}
            >
              <div className="new-nodal-invoice-outer-sec">

                <div className="new-modal-top-sec">
                  <div className="new-modal-heading">
                    All filters
                  </div>
                  <a className="close-image-clr1" onClick={toggleFilterModal}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                      <path d="M1 13L13 1" stroke="black" />
                      <path d="M1 0.999999L13 13" stroke="black" />
                    </svg>{" "}
                  </a>
                </div>
                <div className="invoice-filter-inner-section">
                  <div className="filter-inner invoice-id">
                    <label htmlFor="fname">Invoice ID</label>
                    <input
                      type="text"
                      onChange={(e) => {
                        setInvoiceNumberFilter(e.target.value);
                        setCurrentPage(0);
                      }}
                      value={invoiceNumberFilter}
                      id="invoiceId"
                      name="invoiceId"
                      placeholder="All"
                    />
                  </div>

                  <div className="filter-inner invoice-status">
                    <label htmlFor="invoiceStatus">Invoice Status</label>
                    <div className="custom-dropdown1" ref={statusModalDropdownRef}>
                      <div className="drop-down-inner">
                        <div
                          className="selected-options1"
                          onClick={toggleStatusModalDropdown}
                        >
                          {selectedStatus.length === 0 ? (
                            <div className="placeholder">Select</div>
                          ) : (
                            <>
                              <div
                                className="selected-option1"
                                key={selectedStatus[0]}
                              >
                                {selectedStatus.length ===
                                  invStatusList.length ? (
                                  "All"
                                ) : (
                                  <>
                                    <TruncateFilterFieldView
                                      textContent={
                                        invStatusList.find(
                                          (item) => item._id === selectedStatus[0]
                                        )?.status
                                      }
                                    />
                                    {selectedStatus.length > 1 &&
                                      selectedStatus.length !==
                                      invStatusList.length && (
                                        <div className="selected-option-count">
                                          {selectedStatus.length - 1}+
                                        </div>
                                      )}
                                  </>
                                )}
                              </div>
                            </>
                          )}
                        </div>
                        {isStatusModalDropdownOpen && (
                          <div className="dropdown-list1">
                            {invStatusList.length > 0 && (
                              <>
                                <label
                                  className="checkbox-label1"
                                  key="selectAll"
                                >
                                  <input
                                    type="checkbox"
                                    checked={selectAllStatus}
                                    onChange={handleSelectAllStatusChange}
                                  />
                                  All
                                </label>
                                {invStatusList.map((status) => (
                                  <label
                                    className="checkbox-label1"
                                    key={status._id}
                                  >
                                    <input
                                      type="checkbox"
                                      checked={selectedStatus.includes(
                                        status._id
                                      )}
                                      onChange={() =>
                                        handleCheckboxStatusChange(status._id)
                                      }
                                    />
                                    {status.status && `${status.status}`}
                                  </label>
                                ))}
                              </>
                            )}
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="filter-inner payment-status">
                    <label htmlFor="paymentStatus">Payment Status</label>
                    <div
                      className="custom-dropdown1"
                      ref={paymentStatusModalDropdownRef}
                    >
                      <div className="drop-down-inner">
                        <div
                          className="selected-options1"
                          onClick={togglePaymentStatusModalDropdown}
                        >
                          {selectedPaymentStatus.length === 0 ? (
                            <div className="placeholder">Select</div>
                          ) : (
                            <>
                              <div
                                className="selected-option1"
                                key={selectedPaymentStatus[0]}
                              >
                                {selectedPaymentStatus.length ===
                                  invPaymStatusList.length ? (
                                  "All"
                                ) : (
                                  <>
                                    <TruncateFilterFieldView
                                      textContent={
                                        invPaymStatusList.find(
                                          (item) =>
                                            item._id === selectedPaymentStatus[0]
                                        )?.status
                                      }
                                    />
                                    {selectedPaymentStatus.length > 1 &&
                                      selectedPaymentStatus.length !==
                                      invPaymStatusList.length && (
                                        <div className="selected-option-count">
                                          {selectedPaymentStatus.length - 1}+
                                        </div>
                                      )}
                                  </>
                                )}
                              </div>
                            </>
                          )}
                        </div>
                        {isPaymentStatusModalDropdownOpen && (
                          <div className="dropdown-list1">
                            {invPaymStatusList.length > 0 && (
                              <>
                                <label
                                  className="checkbox-label1"
                                  key="selectAll"
                                >
                                  <input
                                    type="checkbox"
                                    checked={selectAllPaymentStatus}
                                    onChange={handleSelectAllPaymentStatusChange}
                                  />
                                  All
                                </label>
                                {invPaymStatusList.map((paymentstatus) => (
                                  <label
                                    className="checkbox-label1"
                                    key={paymentstatus._id}
                                  >
                                    <input
                                      type="checkbox"
                                      checked={selectedPaymentStatus.includes(
                                        paymentstatus._id
                                      )}
                                      onChange={() =>
                                        handleCheckboxPaymentStatusChange(
                                          paymentstatus._id
                                        )
                                      }
                                    />
                                    {paymentstatus.status &&
                                      `${paymentstatus.status}`}
                                  </label>
                                ))}
                              </>
                            )}
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="filter-inner due-date">
                    <label htmlFor="dueDate" className="calendar-icon">
                      Due Date
                    </label>
                    <div className="date-picker-outer date-picker-outer-all">
                      <div className="custoom-icon-calender custoom-icon-calender-all">
                        <DatePicker
                          oneTap // Use DatePicker instead of DateRangePicker
                          format="dd/MM/yyyy"
                          ranges={ranges}
                          value={selectedDate}
                          onChange={handleDateChange}
                          placement="auto"
                          className="invoice-filter-top-date"
              caretAs={CalendarIcon}
                        />
                      </div>
                    </div>
                  </div>

                </div>
              </div>
              <Modal
                className="delete-modal"
                isOpen={showConfirmationModal}
                onRequestClose={handleCancel}
                contentLabel="Confirm Delete"
                style={{
                  content: {
                    height: "41%",
                    width: "30%",
                    position: "fixed",
                    top: "36%",
                    left: "50%",
                  },
                }}
              >
                <div className="delete-modal-content">
                  <h2>Apply or Discard changes?</h2>
                  <p>
                    Do you want to Apply or Discard filter changes?
                  </p>

                  <div className="delete-modal-buttons">
                    <button className="delete" onClick={handleApplyConfirm} >
                      Apply Changes
                    </button>
                    <button onClick={clearFilters}>
                      Discard Changes
                    </button>
                  </div>
                </div>
              </Modal>
              <div className="filter-buttons">
                <button className="clear-all" onClick={clearFilters}>Clear All</button>
                <button className="apply-filter" onClick={applyFilters}>
                  <svg xmlns="http://www.w3.org/2000/svg" width="13" height="17" viewBox="0 0 13 17" fill="none">
                    <path d="M11.7363 8.81108C11.4276 9.81451 10.4925 10.5444 9.38889 10.5444C8.28471 10.5444 7.35016 9.8141 7.04147 8.81108L0.722221 8.81108C0.323349 8.81108 -1.07845e-06 8.48773 -1.06101e-06 8.08886C-1.04357e-06 7.68998 0.323349 7.36663 0.722221 7.36663L7.04144 7.36663C7.35022 6.3632 8.28529 5.6333 9.38889 5.6333C10.4931 5.6333 11.4276 6.36362 11.7363 7.36663L12.2778 7.36663C12.6767 7.36663 13 7.68998 13 8.08886C13 8.48773 12.6766 8.81108 12.2778 8.81108L11.7363 8.81108ZM9.38889 7.07775C8.83162 7.07775 8.37778 7.53123 8.37778 8.08886C8.37778 8.64613 8.83127 9.09997 9.38889 9.09997C9.94616 9.09997 10.4 8.64648 10.4 8.08886C10.4 7.53158 9.94651 7.07775 9.38889 7.07775Z" fill="white" />
                    <path d="M5.38078 3.17778C5.072 4.18121 4.13693 4.91111 3.03333 4.91111C1.92882 4.91111 0.994035 4.18035 0.68563 3.17687C0.303759 3.15781 -1.07791e-06 2.84216 -1.06101e-06 2.45556C-1.04411e-06 2.06896 0.303748 1.75331 0.685606 1.73425C0.994098 0.730343 1.9294 -4.83911e-07 3.03333 -4.35657e-07C4.13752 -3.87392e-07 5.07206 0.730315 5.38076 1.73333L12.2778 1.73333C12.6767 1.73333 13 2.05668 13 2.45556C13 2.85443 12.6766 3.17778 12.2778 3.17778L5.38078 3.17778ZM3.03333 1.44444C2.47606 1.44444 2.02222 1.89793 2.02222 2.45556C2.02222 3.01283 2.47571 3.46667 3.03333 3.46667C3.5906 3.46667 4.04444 3.01318 4.04444 2.45556C4.04444 1.89828 3.59096 1.44444 3.03333 1.44444Z" fill="white" />
                    <path d="M7.403 14.4444C7.09422 15.4478 6.15916 16.1777 5.05556 16.1777C3.95137 16.1777 3.01682 15.4474 2.70813 14.4444L0.722221 14.4444C0.323349 14.4444 -1.07845e-06 14.121 -1.06101e-06 13.7222C-1.04357e-06 13.3233 0.323349 12.9999 0.722221 12.9999L2.70811 12.9999C3.01689 11.9965 3.95195 11.2666 5.05556 11.2666C6.15974 11.2666 7.09429 11.9969 7.40298 12.9999L12.2778 12.9999C12.6767 12.9999 13 13.3233 13 13.7222C13 14.121 12.6766 14.4444 12.2778 14.4444L7.403 14.4444ZM5.05556 12.711C4.49828 12.711 4.04444 13.1645 4.04444 13.7222C4.04444 14.2794 4.49793 14.7333 5.05556 14.7333C5.61283 14.7333 6.06667 14.2798 6.06667 13.7222C6.06667 13.1649 5.61318 12.711 5.05556 12.711Z" fill="white" />
                  </svg>
                  Apply Filters
                </button>
              </div>
            </Modal>
          </div>
        </div>
        <div className="card-outer1">
          <div className="card-outer">
            <div className="card">
              {isLoading == true ? (
                <div className="datatable-in-invoice">
                  <div className="skeleton-table-container">
                    <table className="skeleton-table" style={{ width: "100%", minWidth: "50rem" }}>
                      <thead>
                        <tr>
                          <th style={{ paddingRight: "44px", textAlign: "left" }}>Invoice ID</th>
                          <th style={{ paddingRight: "44px", textAlign: "left" }}>Due Date</th>
                          <th style={{ paddingRight: "44px", textAlign: "left" }}>Status</th>
                          <th style={{ paddingRight: "44px", textAlign: "left" }}>Payment Status</th>
                          <th style={{ paddingRight: "44px", textAlign: "left" }}>Amount</th>
                          <th style={{ paddingRight: "45px", minWidth: "121.73px", textAlign: "left" }}></th>
                        </tr>
                      </thead>
                      <tbody>
                        {[...Array(rowsPerPage > 10 ? 10 : rowsPerPage)].map((_, index) => (
                          <tr key={index}>
                            <td style={{ paddingRight: "44px" }}>
                              <div
                                style={{
                                  width: "120px",
                                  height: "20px",
                                  backgroundColor: "#e5e7eb",
                                  borderRadius: "4px",
                                  animation: "pulse 1.5s ease-in-out infinite",
                                }}
                              />
                            </td>
                            <td style={{ paddingRight: "44px" }}>
                              <div
                                style={{
                                  width: "100px",
                                  height: "20px",
                                  backgroundColor: "#e5e7eb",
                                  borderRadius: "4px",
                                  animation: "pulse 1.5s ease-in-out infinite",
                                }}
                              />
                            </td>
                            <td style={{ paddingRight: "44px" }}>
                              <div
                                style={{
                                  width: "90px",
                                  height: "24px",
                                  backgroundColor: "#e5e7eb",
                                  borderRadius: "100px",
                                  animation: "pulse 1.5s ease-in-out infinite",
                                }}
                              />
                            </td>
                            <td style={{ paddingRight: "44px" }}>
                              <div
                                style={{
                                  width: "110px",
                                  height: "24px",
                                  backgroundColor: "#e5e7eb",
                                  borderRadius: "100px",
                                  animation: "pulse 1.5s ease-in-out infinite",
                                }}
                              />
                            </td>
                            <td style={{ paddingRight: "44px" }}>
                              <div
                                style={{
                                  width: "100px",
                                  height: "20px",
                                  backgroundColor: "#e5e7eb",
                                  borderRadius: "4px",
                                  animation: "pulse 1.5s ease-in-out infinite",
                                }}
                              />
                            </td>
                            <td style={{ paddingRight: "45px", minWidth: "121.73px" }}>
                              <div
                                style={{
                                  width: "80px",
                                  height: "32px",
                                  backgroundColor: "#e5e7eb",
                                  borderRadius: "4px",
                                  animation: "pulse 1.5s ease-in-out infinite",
                                }}
                              />
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              ) : (
                <div className="datatable-in-invoice">
                  <DataTable
                    value={filteredData}
                    removableSort
                    tableStyle={{
                      minWidth: "50rem",
                      width: "100%",
                      textAlign: "left",
                    }}
                    paginator={filteredData.length > 10}
                    paginatorClassName="recent-invoices-pagination"
                    rows={rowsPerPage} // Set the number of rows per page
                    first={currentPage * rowsPerPage} // Set the current page using currentPage
                    onPage={onPageChange} // Update currentPage when changing pages
                    emptyMessage={
                      <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", padding: "48px 24px", gap: "10px" }}>
                        <svg width="44" height="44" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <rect x="6" y="10" width="32" height="26" rx="3" stroke="#D0D5DD" strokeWidth="2" />
                          <path d="M6 16h32" stroke="#D0D5DD" strokeWidth="2" />
                          <path d="M14 7v6M30 7v6" stroke="#D0D5DD" strokeWidth="2" strokeLinecap="round" />
                          <path d="M13 24h6M13 29h12" stroke="#BDBDBD" strokeWidth="2" strokeLinecap="round" />
                        </svg>
                        <p style={{ margin: 0, fontSize: "15px", fontWeight: "500", color: "#282828" }}>No invoices found</p>
                        <p style={{ margin: 0, fontSize: "13px", color: "#96A8BA" }}>Try adjusting your filters or create a new invoice.</p>
                      </div>
                    }
                  >
                    <Column
                      field="ven_inv_number"
                      header="Invoice ID"
                      className=""
                      sortable
                      style={{ paddingRight: "44px" }}
                    ></Column>
                    <Column
                      field="ven_inv_due_date"
                      body={dateVenInvConvert}
                      header="Due Date"
                      className=""
                      sortable
                      style={{ paddingRight: "44px", left: `${sec3}px` }}
                    ></Column>
                    <Column
                      field="ven_inv_status"
                      header="Status"
                      className=""
                      body={renderStatus}
                      sortable
                      style={{ paddingRight: "44px" }}
                    ></Column>
                    {/* <Column
                      field="ven_inv_payment_status"
                      header="Payment Status"
                      body={(rowData) => (
                        <VendorWisePaymentStatus
                          inv_payment_details={rowData.ven_inv_payment_details}
                          invData={rowData}
                        />
                      )}
                      sortable
                      style={{ paddingRight: "44px" }}
                    ></Column> */}
                    <Column
                      field="ven_inv_payment_status"
                      header="Payment Status"
                      body={(rowData) => (
                        <VendorWisePaymentStatus
                          inv_payment_details={rowData.ven_inv_payment_details}
                          invData={rowData}
                          invoiceId={rowData.ven_inv_number}
                          createdAt={rowData.ven_inv_created_at}
                          paymentStatus={rowData.ven_inv_payment_status}
                        />
                      )}
                      sortable
                      style={{ paddingRight: "44px" }}
                    ></Column>
                    <Column
                      field="ven_inv_total_amount"
                      header="Amount"
                      body={renderAmount}
                      className="amount-bold"
                      sortable
                      style={{ paddingRight: "44px" }}
                    ></Column>
                    <Column
                      field="_id"
                      body={renderVendorInvoiceCTA}
                      className=""
                      style={{
                        paddingRight: "45px",
                        minWidth: "121.73px",
                      }}
                    ></Column>
                  </DataTable>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
      <style>{`
        @keyframes pulse {
          0%, 100% {
            opacity: 1;
          }
          50% {
            opacity: 0.5;
          }
        }
        .skeleton-table-container {
          width: 100%;
          overflow-x: auto;
        }
        .skeleton-table {
          border-collapse: collapse;
          width: 100%;
        }
        .skeleton-table thead th {
          padding: 12px;
          font-weight: 600;
          border-bottom: 1px solid #e5e7eb;
          color: #6b7280;
        }
        .skeleton-table tbody td {
          padding: 16px 12px;
          border-bottom: 1px solid #f3f4f6;
        }
        .skeleton-table tbody tr:last-child td {
          border-bottom: none;
        }
      `}</style>
    </div>
  );
};
export default VendorInvoices;
